export const RESOLVE_TRANSACTION_ACTION = 'MESSAGEBOX.RESOLVE_TRANSACTION_ACTION';
export const OPEN_MESSAGEBOX_TRANSACTION_ACTION = 'MESSAGEBOX.OPEN_MESSAGEBOX_TRANSACTION_ACTION';
export const CLOSE_ALL_MESSAGEBOXES_ACTION = 'MESSAGEBOX.CLOSE_ALL_MESSAGEBOXES_ACTION';
